import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import Auth from "./pages/Auth";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Coach from "./pages/Coach";
import Breathing from "./pages/Breathing";
import Grounding from "./pages/Grounding";
import CBT from "./pages/CBT";
import Journal from "./pages/Journal";
import Mood from "./pages/Mood";
import Levels from "./pages/Levels";
import Sessions from "./pages/Sessions";
import AppShell from "./components/AppShell";

const Protected = ({ children, requireOnboarded = true }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-sm opacity-60">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  return children;
};

const Shell = ({ children }) => <AppShell>{children}</AppShell>;

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/onboarding" element={<Protected requireOnboarded={false}><Onboarding /></Protected>} />
          <Route path="/dashboard" element={<Protected><Shell><Dashboard /></Shell></Protected>} />
          <Route path="/coach" element={<Protected><Shell><Coach /></Shell></Protected>} />
          <Route path="/breathing" element={<Protected><Shell><Breathing /></Shell></Protected>} />
          <Route path="/grounding" element={<Protected><Shell><Grounding /></Shell></Protected>} />
          <Route path="/cbt" element={<Protected><Shell><CBT /></Shell></Protected>} />
          <Route path="/journal" element={<Protected><Shell><Journal /></Shell></Protected>} />
          <Route path="/mood" element={<Protected><Shell><Mood /></Shell></Protected>} />
          <Route path="/levels" element={<Protected><Shell><Levels /></Shell></Protected>} />
          <Route path="/sessions" element={<Protected><Shell><Sessions /></Shell></Protected>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
